import {REQUIRED_ATTRIBUTES} from 'src/modules/event-create/constants';
import {CreationAttribute} from 'src/modules/event-create/typedefs';
import {AttributeDetailInfo} from 'src/openapi/models/AttributeDetailInfo';

const findAttributeDeprecationStatus = (
    attribute: CreationAttribute,
    existedAttributes: AttributeDetailInfo[],
): boolean => {
    const existedAttribute =
        existedAttributes.find(attr => attr.id === parseInt(attribute.id || ''));

    if (existedAttribute && REQUIRED_ATTRIBUTES.includes(existedAttribute.name)) {
        return false;
    }

    return existedAttribute?.deprecated ?? false;
};

export const mergeDeprecatedAttributes = (
    currentAttributes: CreationAttribute[],
    existedAttributes: AttributeDetailInfo[],
): CreationAttribute[] => {
    return currentAttributes.map(attribute => ({
        ...attribute,
        deprecated: findAttributeDeprecationStatus(attribute, existedAttributes),
    }));
};
